import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { Dropdown as ReactBootstrapDropdown } from 'react-bootstrap';
export var BootstrapDropdown = function BootstrapDropdown(_ref) {
  var id = _ref.id,
      toggle = _ref.toggle,
      children = _ref.children;
  return React.createElement(ReactBootstrapDropdown, {
    alignRight: true
  }, React.createElement(ReactBootstrapDropdown.Toggle, {
    id: id,
    as: DropdownToggle
  }, toggle), React.createElement(ReactBootstrapDropdown.Menu, null, children));
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownToggle, _React$Component);

  function DropdownToggle() {
    _classCallCheck(this, DropdownToggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropdownToggle).apply(this, arguments));
  }

  _createClass(DropdownToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          children = _this$props.children;
      return React.createElement("button", {
        type: "button",
        onClick: onClick
      }, children);
    }
  }]);

  return DropdownToggle;
}(React.Component);